import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-327b5b68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contain"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "notice-title"
};
const _hoisted_4 = {
  class: "information"
};
const _hoisted_5 = {
  class: "train-area"
};
const _hoisted_6 = {
  key: 0,
  class: "ml-8"
};
const _hoisted_7 = {
  class: "train-date"
};
import router from '@/router';
import dayjs from 'dayjs';
export default {
  __name: 'index',
  props: {
    noticeData: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const onClick = val => {
      router.push({
        path: '/course/detail',
        query: {
          id: val,
          tab: 'introduction'
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.noticeData, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "notice-block",
          key: item,
          onClick: $event => onClick(item.id)
        }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.courseName), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_Icon, {
          name: "el-icon-Location"
        }), _createTextVNode(" 培训地点：" + _toDisplayString(item.courseModel === '1' ? '线上' : '线下') + " ", 1), item.address ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.address), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_Icon, {
          name: "el-icon-Clock"
        }), _createTextVNode(" 培训时间：" + _toDisplayString(item.courseStartTime ? _unref(dayjs)(+item.courseStartTime).format('YYYY-MM-DD') : 0) + " ~ " + _toDisplayString(item.courseEndTime ? _unref(dayjs)(+item.courseEndTime).format('YYYY-MM-DD') : 0), 1)])])], 8, _hoisted_2);
      }), 128))]);
    };
  }
};